import { z } from 'zod'

import { EmailZ, LocationTypes, LoyaltyProgramCardBase, WithLoyaltyProgramName } from './common'

export const HotelIdZ = z.string()

export type HotelId = z.infer<typeof HotelIdZ>

export const HotelZ = z.object({
	email: EmailZ.nullable(),
})

export type Hotel = z.infer<typeof HotelZ>

export const HotelInfoZ = z.object({
	hotel: HotelZ,
})
export type HotelInfo = z.infer<typeof HotelInfoZ>

export interface HotelSearchResult {
	label: string
	location_type?: LocationTypes
	latitude: number
	longitude: number
}

export interface HotelCitySearchResult extends HotelSearchResult {
	city_name: string
	code: string
	country_iso: string
	country_name: string
}

export type HotelLoyaltyProgramType = 'most_popular' | 'also_popular' | 'other'

export interface HotelLoyaltyProgram extends WithLoyaltyProgramName {
	id: number
	loyalty_program_logo: string | null
	loyalty_program_type: HotelLoyaltyProgramType
	hotel_chain_code: string | null
}

export interface HotelLoyaltyProgramCard extends LoyaltyProgramCardBase {
	loyalty_program_code: string
	loyalty_program: HotelLoyaltyProgram
}
